var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.279 7.304 4.72 8.696 10 10.808l5.278-2.112-.556-1.392L10 9.192z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.75 4.25H2.25v11.5h15.5zm-14 10v-8.5h12.5v8.5z",
    clipRule: "evenodd"
  })));
};
export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjI3ODU0IDcuMzAzNzFMNC43MjE0NiA4LjY5NjQzTDEwIDEwLjgwNzhMMTUuMjc4NSA4LjY5NjQzTDE0LjcyMTUgNy4zMDM3MUwxMCA5LjE5MjI5TDUuMjc4NTQgNy4zMDM3MVoiIC8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTcuNzUgNC4yNUgyLjI1VjE1Ljc1SDE3Ljc1VjQuMjVaTTMuNzUgMTQuMjVWNS43NUgxNi4yNVYxNC4yNUgzLjc1WiIgLz4KPC9zdmc+Cg==";